import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-etapas',
  templateUrl: './etapas.component.html',
  styleUrls: ['./etapas.component.scss']
})
export class EtapasComponent implements OnInit {

  public arrayTriagem: [];
  query: string;

  constructor(
    private router: Router,
    public util: UtilService,
    private ajax: AjaxService
    
  ) { }

  ngOnInit() {
    this.buscar();
  }

  salvar(){

  }

  voltar(){
    this.router.navigate(['/lista-programa']);
  }

  buscar(){
    this.util.showLoading();
    //let url = API + "Triagem/Triagem";  
    let url = "fake-data/etapas.json";  
    return this.ajax.get(url)
    .subscribe(response  => {
      this.arrayTriagem = response;

      this.util.closeLoading();      
    }, err => {
      debugger
      this.util.closeLoading();
      this.util.toasterShowError("Atenção", "Erro ao Buscar Triagem");
    });
  }

}
